module.exports = __webpack_public_path__ + "static/media/post2-1.22402ea8.JPG";